import { useState } from 'react';
import { VenuesContainer, VenuesContentContainer, StyledMotionDiv } from './Venues.styles';
import { Typography } from '@mui/material';
import TabsMenu from '../../components/TabsMenu/TabsMenu';
import GeneralInfo from '../../components/Venues/GeneralInfo/GeneralInfo';
import Legal from '../../components/Venues/Legal/Legal';
import VenueSettings from '../../components/Venues/Settings/VenueSettings';

const Venues = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (newValue) => {
    setSelectedTab(newValue);
  };

  const renderTabContent = () => {
    switch (selectedTab) {
      case 0:
        return <GeneralInfo />;
      case 1:
        return <Legal />;
      case 2:
        return <VenueSettings />;
      default:
        return <GeneralInfo />;
    }
  };

  return (
    <VenuesContainer>
      <VenuesContentContainer>
        <StyledMotionDiv
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          <Typography variant="h4">Venues</Typography>

          <TabsMenu options={['General Info', 'Legal', 'Settings']} value={selectedTab} onChange={handleTabChange} />

          {renderTabContent()}
        </StyledMotionDiv>
      </VenuesContentContainer>
    </VenuesContainer>
  );
};

export default Venues;
